// System
import { useEffect } from 'react';
import { MenuItem, Stack } from '@mui/material';
// Components
import { AtLocator } from '@Components/shared/locators/AtLocator';
// Hooks
import { useFormContext } from 'react-hook-form';
import { RHFSelect, RHFTextField } from '@Components/hook-form';
import { useUpdateProviderConfig } from '@Modal/hooks/providers/useUpdateProviderConfig';
// Styles
import Styles from './UpdateProviderConfigContet.module.scss';

export const UpdateProviderConfigContent = () => {
  const { selectedProviderConfig } = useUpdateProviderConfig();
  const { setValue } = useFormContext();

  useEffect(() => {
    if (selectedProviderConfig) {
      setValue('maxWin', selectedProviderConfig.maxWin);
      setValue('defaultBet', selectedProviderConfig.defaultBet);
      setValue('isRoundable', selectedProviderConfig.isRoundable);
      setValue('minBet', selectedProviderConfig.minBet);
      setValue('maxBet', selectedProviderConfig.maxBet);
      setValue('betSuggestions', selectedProviderConfig.betSuggestions);
      setValue('minAutoCashout', selectedProviderConfig.minAutoCashout);
      setValue('maxAutoCashout', selectedProviderConfig.maxAutoCashout);
      setValue('defaultAutoCashout', selectedProviderConfig.defaultAutoCashout);
      setValue('currency', selectedProviderConfig.currency);
    }
  }, [selectedProviderConfig, setValue]);

  return (
    <Stack className={Styles.UpdateProviderConfigContent}>
      <AtLocator type="text-field" name="currency" key="currency">
        <RHFTextField name="currency" label="Currency" />
      </AtLocator>
      <AtLocator type="text-field" name="maxWin" key="maxWin">
        <RHFTextField name="maxWin" label="Max win" />
      </AtLocator>
      <AtLocator type="text-field" name="defaultBet" key="defaultBet">
        <RHFTextField name="defaultBet" label="Default bet" />
      </AtLocator>
      <RHFSelect
        label="Is roundable?"
        name="isRoundable"
        variant="outlined"
        sx={{ width: '100%', marginTop: '6px', marginBottom: '15px' }}
      >
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
      </RHFSelect>
      <AtLocator type="text-field" name="minBet" key="minBet">
        <RHFTextField name="minBet" label="Min bet" />
      </AtLocator>
      <AtLocator type="text-field" name="maxBet" key="maxBet">
        <RHFTextField name="maxBet" label="Max bet" />
      </AtLocator>
      <AtLocator type="text-field" name="betSuggestions" key="betSuggestions">
        <RHFTextField name="betSuggestions" label="Bet suggestions" />
      </AtLocator>
      <AtLocator type="text-field" name="minAutoCashout" key="minAutoCashout">
        <RHFTextField name="minAutoCashout" label="Min auto cashout" />
      </AtLocator>
      <AtLocator type="text-field" name="maxAutoCashout" key="maxAutoCashout">
        <RHFTextField name="maxAutoCashout" label="Max auto cashout" />
      </AtLocator>
      <AtLocator type="text-field" name="defaultAutoCashout" key="defaultAutoCashout">
        <RHFTextField name="defaultAutoCashout" label="Default auto cashout" />
      </AtLocator>
    </Stack>
  );
};
